import { render, staticRenderFns } from "./PagoEmpresasAdministracion.vue?vue&type=template&id=2c45a443&scoped=true&"
import script from "./PagoEmpresasAdministracion.vue?vue&type=script&lang=js&"
export * from "./PagoEmpresasAdministracion.vue?vue&type=script&lang=js&"
import style0 from "./PagoEmpresasAdministracion.vue?vue&type=style&index=0&id=2c45a443&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c45a443",
  null
  
)

export default component.exports